import { render, staticRenderFns } from "./d-card1.vue?vue&type=template&id=28f9e69c&scoped=true"
import script from "./d-card1.vue?vue&type=script&lang=js"
export * from "./d-card1.vue?vue&type=script&lang=js"
import style0 from "./d-card1.vue?vue&type=style&index=0&id=28f9e69c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f9e69c",
  null
  
)

export default component.exports